module.exports = __webpack_public_path__ + "img/16_111.6ebacdd1.png";